var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6804 16.25H5.18042C4.49292 16.25 3.93042 15.6875 3.93042 15V5C3.93042 4.3125 4.49292 3.75 5.18042 3.75H12.6804C13.3679 3.75 13.9304 4.3125 13.9304 5V15C13.9304 15.6875 13.3679 16.25 12.6804 16.25ZM12.6804 26.25H5.18042C4.49292 26.25 3.93042 25.6875 3.93042 25V20C3.93042 19.3125 4.49292 18.75 5.18042 18.75H12.6804C13.3679 18.75 13.9304 19.3125 13.9304 20V25C13.9304 25.6875 13.3679 26.25 12.6804 26.25ZM17.6804 26.25H25.1804C25.8679 26.25 26.4304 25.6875 26.4304 25V15C26.4304 14.3125 25.8679 13.75 25.1804 13.75H17.6804C16.9929 13.75 16.4304 14.3125 16.4304 15V25C16.4304 25.6875 16.9929 26.25 17.6804 26.25ZM16.4304 10V5C16.4304 4.3125 16.9929 3.75 17.6804 3.75H25.1804C25.8679 3.75 26.4304 4.3125 26.4304 5V10C26.4304 10.6875 25.8679 11.25 25.1804 11.25H17.6804C16.9929 11.25 16.4304 10.6875 16.4304 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.61fdaf0af69193feffc3fdbbf1f6809b.svg";
export { ForwardRef as ReactComponent };